import { ModalsPanelsRegistry } from "@libs/modal-panels/modal-panels";
import { RegisteredModal } from "modal-registry";

import { useCan } from "permission-guards/use-can";
import { Suspense, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { AnimatedSwitch } from "react-router-transition";
import { bounceTransition, mapStyles } from "router-helpers";
import { HQRouter } from "router-hq";
import { LoadingView } from "router-loading-view";
import { FullScreenLayout } from "./components/layout/full-screen-layout/full-screen-layout.template";
import { AuthenticatedRoutes, UnauthenticatedRoutes } from "./navigation";
import { GetRouteMeta } from "./route-helper";
import { selectAccessToken } from "./store/modules/users/users.selectors";

export const MainRouter = () => {
  const isAuthenticated = useSelector(selectAccessToken);
  const { can, isReady } = useCan();
  const location = useLocation();

  const isAuthDomain = window.location.host.split(".")[0] === "auth";
  const isHQLocation = location.pathname.includes("/hq");

  const Container =
    GetRouteMeta(
      isAuthenticated ? AuthenticatedRoutes : UnauthenticatedRoutes,
      location?.pathname,
    )?.layout || FullScreenLayout;

  useEffect(() => {
    if (!isAuthenticated) {
      UnauthenticatedRoutes.forEach((item) => {
        (item.component as any).preload && (item.component as any).preload();
      });
    }
  }, [isAuthenticated]);

  // useEffect(() => {
  //   UserTracker.track(`Navigated to ${location.pathname}`, {
  //     path: location.pathname,
  //     search: location.search
  //   });
  // }, [location.pathname, location.search]);

  const enableSubDomains =
    !window.location.href.includes("localhost") &&
    !window.location.href.includes("vercel.app");

  const specialDefaultPage = useMemo(() => {
    const isRegisterDomain = window.location.host.split(".")[0] === "register";
    const isHQDomain = window.location.host.split(".")[0] === "hq";
    const isRoadmapDomain = window.location.host.split(".")[0] === "roadmap";
    const isLoginDomain =
      window.location.host.split(".")[0] === "login" ||
      window.location.host.split(".")[0] === "clickconnector";
    if (isRegisterDomain) {
      return "/register";
    }
    if (isHQDomain) {
      return `/hq`;
    }
    if (isRoadmapDomain) {
      return `/roadmap`;
    }
    if (isLoginDomain) {
      return `/signin`;
    }
    return `/login`;
  }, []);

  if (isHQLocation) {
    return <HQRouter />;
  }

  if (isAuthenticated) {
    if (!isReady) {
      return LoadingView;
    }
    return (
      <>
        <Container>
          <Suspense fallback={LoadingView}>
            <Switch>
              {AuthenticatedRoutes.filter(
                (e) => !e.requiredPermission || can!(e.requiredPermission),
              ).map((item) => (
                <Route
                  path={item.path}
                  component={item.component}
                  key={item.path}
                  // exact={true}
                ></Route>
              ))}
              <Route
                path="*"
                component={({ location }) => (
                  <Redirect
                    to={{
                      ...location,
                      pathname: `/home`,
                    }}
                  />
                )}
              />
            </Switch>
          </Suspense>
          <ModalsPanelsRegistry modals={RegisteredModal} />
        </Container>
      </>
    );
  }
  return (
    <Suspense fallback={LoadingView}>
      <AnimatedSwitch
        atEnter={bounceTransition.atEnter}
        atLeave={bounceTransition.atLeave}
        atActive={bounceTransition.atActive}
        mapStyles={mapStyles}
        className="route-wrapper"
      >
        {UnauthenticatedRoutes.map((item) => (
          <Route
            path={item.path}
            component={item.component}
            key={item.path}
          ></Route>
        ))}
        <Route
          path="*"
          component={({ location }) => (
            <Redirect
              to={{
                ...location,
                pathname: specialDefaultPage,
              }}
            />
          )}
        />
      </AnimatedSwitch>
    </Suspense>
  );
};
